module.exports = __webpack_public_path__ + "img/11_11.b33d1cd1.png";